import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Si la ficha se abrió con una ruta antigua (por ID), cambia la dirección a la ruta legible
 * sin recargar ni añadir historial, conservando ?búsqueda y #sección. Así "Copiar enlace" comparte la legible.
 */
export function CanonicalPath({
  to
}: {
  to: string;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (decodeURIComponent(location.pathname).replace(/\/+$/, '').toLowerCase() !== to.toLowerCase()) {
      navigate(`${to}${location.search}${location.hash}`, {
        replace: true
      });
    }
  }, [to, location.pathname, location.search, location.hash, navigate]);
  return null;
}